var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTestimonialsBackgroundIllustration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 434,
    viewBox: "0 0 1440 434",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1475 0v436c-120.4 0-218-97.603-218-218S1354.6 0 1475 0zM226 436V0c120.398 0 218 97.603 218 218s-97.605 218-218 218z",
    fill: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M442 436V0c120.398 0 218 97.603 218 218s-97.605 218-218 218z",
    fill: "currentcolor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M659 436V0c120.398 0 218 97.603 218 218s-97.605 218-218 218zM225.847 430.648c-1.113-56.304-15.941-114.13-59.23-157.146-27.567-27.508-62.721-46.275-101.016-53.926 38.298-7.644 73.453-26.412 101.016-53.926 41.3-41.039 57.881-96.168 59.286-149.514 0-2.516.097-5.033.097-7.536V0h-24.941c-3.283 0-6.566.069-9.849.235-48.199 2.31-96.773 21.501-133.065 57.577C19.697 96.03.306 169.369 0 219.451v.193c.306 50.179 19.683 123.408 58.159 161.654 37.112 36.905 87.106 56.125 136.32 57.701h31.368v-8.352zM71.874 67.974c0 .139 0 0 0 0z",
    fill: "currentcolor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M866 434V0a426.49 426.49 0 01164.55 33.027c52.17 21.809 99.57 53.776 139.5 94.077 39.93 40.301 71.61 88.147 93.22 140.804S1296 377.004 1296 434H866z",
    fill: "currentcolor"
  })));
}
export default SvgTestimonialsBackgroundIllustration;